import { DESIGN_SYSTEM_CSS } from '../config';

export function loadDesignSystemCSS() {
  if (!document.querySelector(`link[href="${DESIGN_SYSTEM_CSS}"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = DESIGN_SYSTEM_CSS;
    document.head.appendChild(link);
  }
}
